import * as React from "react";
import { createPortal } from "react-dom";

type PortalPropTypes = {
  children: React.ReactElement;
  rootId: string;
};

const Portal = ({ children, rootId }: PortalPropTypes): React.ReactPortal => {
  let portalRoot = document.getElementById(rootId);
  if (!portalRoot) {
    portalRoot = document.createElement("div");
    portalRoot.setAttribute("id", "portal");
    document.body.appendChild(portalRoot);
  }
  const el = document.createElement("div");

  React.useEffect(() => {
    portalRoot.appendChild(el);
    return (): void => {
      portalRoot.removeChild(el);
    };
  }, [el, portalRoot]);

  return createPortal(children, el);
};

export default Portal;
